module.exports = __webpack_public_path__ + "media/images/hero-allcare-banner-640-8e1a12177d03ccc127450336ca145d10.webp";